function mapElementRowToDb(element) {
    const svgObj = {
        x: element.x,
        y: element.y,
        rotation: element.rotation,
        scale: element.scale,
        svg: element.svg,
    };

    if (element.model) {
        svgObj.model = element.model;
        delete svgObj.svg;
    }

    return {
        id: element.id,
        name: element.name,
        nameI18n: element.nameI18n,
        svgInfo: svgObj,
        bookable: element.bookable,
    };
}

export default mapElementRowToDb;
